import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    username: localStorage.getItem('username'),
    email: localStorage.getItem('email'),
    token: localStorage.getItem('token') || '',
    accessControl: JSON.parse(localStorage.getItem('accessControl')) || []
  },
  getters: {
    loggedIn: state => {
      // return state.loggedIn
      return !!state.token
    }
  },
  mutations: {
    login (state, token) {
      state.token = token
      state.accessControl = JSON.parse(localStorage.getItem('accessControl')) || []
      state.username = localStorage.getItem('username')
      state.email = localStorage.getItem('email')
    },
    logout (state) {
      state.token = ''
    },
    setAccessControl (state, access_control) {
      // use this to ovveride access for testing with different authorization levels
      state.accessControl = access_control
    }
  },
  actions: {
    login ({ commit }, credentials) {
      return Vue.prototype.$axios.post('users/sign-in', credentials)
        .then((response) => {
          // decrypt key
          const base64Url = response.data.token.split('.')[1]
          const base64 = base64Url.replace('-', '+').replace('_', '/')
          const keyObj = JSON.parse(window.atob(base64))
          console.log(keyObj)
          // save key info to local storage
          localStorage.setItem('token', response.data.token)
          localStorage.setItem('accessControl', JSON.stringify(keyObj.accessControl))
          localStorage.setItem('username', keyObj.username)
          localStorage.setItem('email', keyObj.email)
          Vue.prototype.$axios.defaults.headers.common.Authorization = `Bearer ${response.data.token}`
          // update state
          commit('login', response.data.token)
          return response
        })
    },
    logout ({ commit }) {
      commit('logout')
      localStorage.removeItem('token')
      delete Vue.prototype.$axios.defaults.headers.common['Authorization']
    }
  }
}
